// extracted by mini-css-extract-plugin
export default {"badge__status":"styles_badge__status__xdVmQ"};